'use strict';

var angularModule = angular.module('t2g.common.filter.currencyFilter', []);

module.exports = angularModule;

angularModule.filter('currency', function () {
    return function (amount) {
        return (amount / 100).toLocaleString('de-DE', {minimumFractionDigits: 2});
    };
});
